<template>
  <a-config-provider :locale="locale">
    <div id="app"><router-view /></div>
  </a-config-provider>
</template>

<script>
import { getDomTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'

export default {
  computed: {
    locale () { return this.$i18n.getLocaleMessage(this.$i18n.locale).antLocale }
  },
  watch: {
    '$i18n.locale': 'updateTitle',
    '$route': { handler: 'updateTitle', immediate: true }
  },
  methods: {
    updateTitle () {
      const title = this.$route.meta && this.$route.meta.title
      setDocumentTitle(title ? `${i18nRender(title)} - ${getDomTitle()}` : getDomTitle())
    }
  }
}
</script>
